module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-container reset-pass-container"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_c('section', {
    staticClass: "login-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'activate')),
      expression: "(state == 'activate')"
    }],
    staticClass: "m-box signup"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('activate.title')))]), _vm._v(" "), _c('p', {
    staticClass: "mb-3 body-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('activate.detail')) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cognitoErrorMsg),
      expression: "cognitoErrorMsg"
    }]
  }, [_c('div', {
    staticClass: "orange--text",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    }
  }), _vm._v("\n              " + _vm._s(_vm.cognitoErrorMsg) + "\n            ")])]), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.activationFormValid),
      callback: function($$v) {
        _vm.activationFormValid = $$v
      },
      expression: "activationFormValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('user-params.username'),
      "rules": _vm.usernameRules,
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.temp_password'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.passwordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordVisible = !_vm.passwordVisible); },
      "type": _vm.passwordVisible ? 'text' : 'password'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.newpassword'),
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.newPasswordVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.newPasswordVisible = !_vm.newPasswordVisible); },
      "type": _vm.newPasswordVisible ? 'text' : 'password'
    },
    on: {
      "keyup": _vm.passwordReinputValidate
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "passwordReinput",
    attrs: {
      "color": "white",
      "label": _vm.$t('activate.passwordreinput'),
      "rules": _vm.passwordReinputRules,
      "required": "",
      "append-icon": _vm.passwordReinputVisible ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.passwordReinputVisible = !_vm.passwordReinputVisible); },
      "type": _vm.passwordReinputVisible ? 'text' : 'password'
    },
    model: {
      value: (_vm.passwordReinput),
      callback: function($$v) {
        _vm.passwordReinput = $$v
      },
      expression: "passwordReinput"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 "
  }, [_c('v-card', {
    staticClass: "ma-1 pa-3 body-2 grey black--text",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "EULA"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('activate.agreement_msg'))
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "body-1 ml-1 mt-3"
  }, [_c('v-checkbox', {
    staticClass: "body-1 activate-agree-checkbox",
    attrs: {
      "label": _vm.$t('activate.agree'),
      "required": "",
      "rules": _vm.checkboxRules
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    class: !_vm.activationFormValid || _vm.submitted ? 'grey lighten-1' : 'blue',
    attrs: {
      "disabled": !_vm.activationFormValid || _vm.submitted
    },
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("activate.submit")) + "\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.state == 'complete')),
      expression: "(state == 'complete')"
    }]
  }, [_c('p', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("activate.complete")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("login.login")))])], 1)]), _vm._v(" "), _c('login-footer')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-09cb96ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Activate.vue
// module id = 1905
// module chunks = 0